import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Panel from 'src/Components/shared/Panel'
import { If } from 'src/deprecated/Conditionals'

const propTypes = {
  className: PropTypes.string,
  isFha: PropTypes.bool,
  isConsolidation: PropTypes.bool
}

const RefiHeading = ({ isFha, isConsolidation, ...restProps }) => (
  <Panel.Heading {...restProps}>
    <If condition={isFha}>
      <FormattedMessage
        id='Homeowner.interest.refiHeadline.fha'
        defaultMessage='What could a refi save you in interest and FHA Mortgage Insurance?'
      />
    </If>
    <If condition={!isFha}>
      <If condition={isConsolidation}>
        <FormattedMessage
          id='Homeowner.interest.refiHeadline.consolidation'
          defaultMessage='What could combining your loans save you in interest?'
        />
      </If>
      <If condition={!isConsolidation}>
        <FormattedMessage
          id='Homeowner.interest.refiHeadline.notConsolidation'
          defaultMessage='What could a refi save you in interest?'
        />
      </If>
    </If>
  </Panel.Heading>
)

RefiHeading.propTypes = propTypes

export default RefiHeading
